import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';

export const EntitlementIconStyle = styled.div`
  img {
    width: 100%;
    height: 100%;
  }
  display: flex;
  align-items: center;
`;

export const TitleStyle = styled.div`
  padding-bottom: ${token('space.050')};
`;
